import fs from 'node:fs'
import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { unique } from '@cli-utils/shared.js'
import { loadManifest } from '@core-engine/snapshots/store/load-manifest.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'

export function schemaManifestContainsMailchimpImports(
  cwd: string,
  config: ResolvedBetterstartConfig,
  schemaName: string
): boolean {
  const manifest = loadManifest(cwd, schemaName)
  if (!manifest) {
    return false
  }

  const namespace = config.frameworkConfig.next.namespace
  const markers = [
    applyAdminNamespaceToContent('@admin/actions/mailchimp/add-to-mailchimp-audience', namespace),
    applyAdminNamespaceToContent('@admin/actions/mailchimp/mailchimp', namespace),
    'addToMailchimpAudience('
  ]
  const liveManifestPaths = unique([
    ...manifest.files.map((file) => file.path),
    ...manifest.skipped
  ])

  return liveManifestPaths.some((filePath) => {
    const fullPath = path.join(cwd, ...filePath.split('/'))
    if (!fs.existsSync(fullPath) || !fs.statSync(fullPath).isFile()) {
      return false
    }

    const content = fs.readFileSync(fullPath, 'utf-8')
    return markers.some((marker) => content.includes(marker))
  })
}
